import Vue from 'vue'
import store from '~/store'
import router from '~/router'
import App from '~/components/App'
import {i18n} from '~/plugins/i18n'
import Notifications from 'vue-notification'

import '~/plugins'
import '~/filters'
import '~/components'
import moment from "moment";

Vue.config.productionTip = false

Vue.use(Notifications)

Vue.filter('prettyDate',function(created){
  return moment(created).format('DD. MMMM YYYY')
})

new Vue({
  i18n,
  store,
  router,
  ...App
})